import { getProductFilter } from '~/features/ProductList/utils';
import { AttributeFilterParameter } from '~/lib/data-contract/auto-generated/loop54-api-model';
import usePopularEntities from '~/services/loop54/hooks/usePopularEntities';
import { Loop54ProductAttributes } from '~/services/loop54/types';
import { reduceLoop54Product } from '~/services/loop54/utils';

type Arguments = {
    amount?: number;
    onlyShowInStock?: boolean;
    applyFilters?: AttributeFilterParameter[];
    orFilters?: AttributeFilterParameter[];
};

type filter = {
    type: string;
    attributeName?: Loop54ProductAttributes;
    value: string | number | boolean;
};

export default function usePopularResults({
    amount = 10,
    onlyShowInStock = true,
    applyFilters,
    orFilters,
}: Arguments) {
    const filters: filter[] = applyFilters ? ([...applyFilters] as filter[]) : [getProductFilter()];

    if (onlyShowInStock) {
        filters.push({
            type: 'attribute',
            attributeName: Loop54ProductAttributes.InStock,
            value: onlyShowInStock,
        });
    }

    const resultsFilters: (
        | AttributeFilterParameter
        | {
              or: AttributeFilterParameter[];
          }
    )[] = [...(filters as AttributeFilterParameter[])];

    if (!!orFilters) {
        resultsFilters.push({
            or: orFilters as AttributeFilterParameter[],
        });
    }

    return usePopularEntities(
        {
            resultsOptions: {
                filter: {
                    and: resultsFilters,
                },
                sortBy: [{ type: 'popularity' }],
                take: amount,
                skip: 0,
            },
            behaviorType: 'purchase',
            entityType: ['Product'],
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
